import { Category } from "@/components/catelog/category-card";

export type MasterDataState = {
  categories: Category[];
  setCategories: (categories: Category[]) => void;
  getCategories: () => Category[];
  clearCategories: () => void;

  fullCategories: Category[];
  setFullCategories: (fullCategories: Category[]) => void;
  getFullCategories: () => Category[];
  clearFullCategories: () => void;

  deals: Category[];
  setDeals: (deals: Category[]) => void;
  getDeals: () => Category[];
  clearDeals: () => void;

  promoBanners: PromoBanner[];
  setPromoBanners: (promoBanners: PromoBanner[]) => void;
  getPromoBanners: () => PromoBanner[];
  clearPromoBanners: () => void;

  showBannerPopup: boolean;
  setShowBannerPopup: (show: boolean) => void;
  currentBannerPopup: PromoBanner | null;
  setCurrentBannerPopup: (banner: PromoBanner | null) => void;
  isServiceModalOpen: boolean;
  setIsServiceModalOpen: (isOpen: boolean) => void;
};

export const createMasterDataSlice = (
  set: (state: Partial<MasterDataState>) => void,
  get: () => MasterDataState
) => ({
  categories: [],
  setCategories: (categories: Category[]) => set({ categories }),
  getCategories: () => get().categories,
  clearCategories: () => set({ categories: [] }),

  fullCategories: [],
  setFullCategories: (fullCategories: Category[]) => set({ fullCategories }),
  getFullCategories: () => get().fullCategories,
  clearFullCategories: () => set({ fullCategories: [] }),

  deals: [],
  setDeals: (deals: Category[]) => set({ deals }),
  getDeals: () => get().deals,
  clearDeals: () => set({ deals: [] }),

  promoBanners: [],
  setPromoBanners: (promoBanners: PromoBanner[]) => set({ promoBanners }),
  getPromoBanners: () => get().promoBanners,
  clearPromoBanners: () => set({ promoBanners: [] }),

  showBannerPopup: false,
  setShowBannerPopup: (show: boolean) => set({ showBannerPopup: show }),
  currentBannerPopup: null,
  setCurrentBannerPopup: (banner: PromoBanner | null) => set({ currentBannerPopup: banner }),
  isServiceModalOpen: false,
  setIsServiceModalOpen: (isOpen: boolean) => set({ isServiceModalOpen: isOpen }),
})